import { Linkedin, Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SITE } from "@/config/site";

const SOCIAL_ICONS = { LinkedIn: Linkedin, Facebook: Facebook, Instagram: Instagram };

export const Footer = () => (
  <footer className="bg-navydeep text-white" data-testid="site-footer">
    <div className="container-tsm grid gap-12 py-16 lg:grid-cols-12 lg:py-20">
      <div className="lg:col-span-5">
        <a href="/" data-testid="footer-logo-link" aria-label="TSM Group CLE home">
          <Logo light />
        </a>
        <p className="mt-6 max-w-md text-sm leading-relaxed text-white/60" data-testid="footer-service-line">
          {SITE.serviceLine}
        </p>
        <p className="mt-4 max-w-md font-mono text-[11px] uppercase tracking-[0.22em] text-gold" data-testid="footer-tagline">
          Think Safe Mitigation — Know the risk. Make your next move.
        </p>
        <div className="mt-6 flex gap-3">
          {SITE.social.map((s) => {
            const Icon = SOCIAL_ICONS[s.label];
            return (
              <a
                key={s.label}
                href={s.href}
                aria-label={s.label}
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="inline-flex h-10 w-10 items-center justify-center rounded-sm border border-white/20 text-white/70 transition-all hover:border-gold hover:text-gold"
              >
                <Icon className="h-4 w-4" />
              </a>
            );
          })}
        </div>
      </div>

      <div className="lg:col-span-2" data-testid="footer-tsm4">
        <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-gold">TSM4</h3>
        <ul className="mt-5 space-y-3 text-sm text-white/75">
          <li><a href="/mitivise" data-testid="footer-link-mitivise" className="transition-colors hover:text-gold">MITIVISE Platform</a></li>
          <li><a href="/tsm4/background-screening" data-testid="footer-link-screening" className="transition-colors hover:text-gold">Background Screening</a></li>
          <li><a href="/tsm4/drug-testing" data-testid="footer-link-drug-testing" className="transition-colors hover:text-gold">Drug Testing</a></li>
          <li><a href="/tsm4/fingerprinting" data-testid="footer-link-fingerprinting" className="transition-colors hover:text-gold">Fingerprinting</a></li>
        </ul>
      </div>

      <div className="lg:col-span-2">
        <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-gold">Explore</h3>
        <ul className="mt-5 space-y-3 text-sm text-white/75">
          <li><a href="/about" data-testid="footer-link-about" className="transition-colors hover:text-gold">About TSM</a></li>
          <li><a href="/workshops" data-testid="footer-link-workshops" className="transition-colors hover:text-gold">Workshops &amp; Resources</a></li>
          <li><a href="/contact" data-testid="footer-link-request" className="transition-colors hover:text-gold">Request a Service</a></li>
          <li><a href="/privacy" data-testid="footer-link-privacy" className="transition-colors hover:text-gold">Privacy Policy</a></li>
          <li><a href="/terms" data-testid="footer-link-terms" className="transition-colors hover:text-gold">Terms of Use</a></li>
          <li><a href="/accessibility" data-testid="footer-link-accessibility" className="transition-colors hover:text-gold">Accessibility</a></li>
        </ul>
      </div>

      <div className="lg:col-span-3" data-testid="footer-contact">
        <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-gold">Contact</h3>
        <ul className="mt-5 space-y-3 text-sm text-white/75">
          <li className="flex items-center gap-3">
            <Phone className="h-4 w-4 shrink-0 text-gold" />
            <span data-testid="footer-phone">{SITE.phone}</span>
          </li>
          <li className="flex items-center gap-3">
            <Mail className="h-4 w-4 shrink-0 text-gold" />
            <span data-testid="footer-email">{SITE.email}</span>
          </li>
          <li className="flex items-center gap-3">
            <MapPin className="h-4 w-4 shrink-0 text-gold" />
            <span>Service Area: {SITE.serviceArea}</span>
          </li>
          <li><a href="/admin" data-testid="footer-link-admin" className="inline-block pt-1 text-xs text-white/40 transition-colors hover:text-gold">Admin</a></li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="container-tsm space-y-4 py-8">
        <p className="text-xs text-white/45" data-testid="footer-copyright">
          &copy; {new Date().getFullYear()} TSM Group CLE. All rights reserved.
        </p>
        <p className="max-w-4xl text-xs leading-relaxed text-white/40" data-testid="footer-disclaimer">
          TSM Group CLE provides business risk management, compliance, and operational services. Information provided
          through this website is for general business purposes and is not legal advice. Businesses remain responsible
          for determining and meeting requirements applicable to their organization and industry.
        </p>
      </div>
    </div>
  </footer>
);
